import { Component, Input, computed } from '@angular/core';

@Component({
  selector: 'app-icon',
  standalone: true,
  template: `
    <div
      [style.mask-image]="iconUrl()"
      [style.-webkit-mask-image]="iconUrl()"
      [class]="class"
      style="display: inline-block; mask-repeat: no-repeat; mask-position: center; mask-size: contain; -webkit-mask-repeat: no-repeat; -webkit-mask-position: center; -webkit-mask-size: contain; background-color: currentColor;"
    ></div>
  `
})
export class IconComponent {
  /** Name des Icons in assets/icons (ohne .svg Endung) */
  @Input({ required: true }) name!: string;

  /** Optionale Tailwind Klassen für Farbe und Größe (z.B. 'w-6 h-6 text-blue-500') */
  @Input() class: string = 'w-6 h-6';

  protected iconUrl = computed(() => `url('assets/icons/${this.name}.svg')`);
}
